import './App.css';
import Memberships from './components/Memberships';
import Events from './components/Events';
import Iframe from './components/Iframe.js'
import Main from './components/Main.js'
import Events2223 from './components/Events2223';
import Gallery from './components/Gallery';
import Team from './components/Team';
import UpComingEvns from './components/UpComingEvns';
import { Route, Routes, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';


import { teamDataMap } from './jsonfiles/teamDataMap';
import { events5 } from './jsonfiles/Events5';
import { Event21 } from './jsonfiles/Event21';
import { event20 } from './jsonfiles/Event20';
import { event19 } from './jsonfiles/Event19';
import { event18 } from './jsonfiles/Event18';
import { Event23 } from './jsonfiles/Event23'
import { event24 } from './jsonfiles/Event24';
import { event25 } from './jsonfiles/Event25';


function App() {
  return (
    <div className="App text-center">
      <div className='w-full h-screen'>
        <Routes>
          <Route path="/webathon" element={<Iframe url='https://webathon-4-0.vercel.app/' />} />
          <Route path="/tesseract" element={<Iframe url='https://tournament-event-backup-rose.vercel.app/' />} />

          {/* All / routes under Main */}
          <Route path="/" element={<Main />}>
            <Route path="events" element={<Events />}>
              <Route index element={<Navigate replace to="events25-26" />} />
              <Route path="events25-26" element={<Events2223 props={{ year: "2025 - 2026", imgspath: 'events5', eventsjson: event25 }} />} />
              <Route path="events24-25" element={<Events2223 props={{ year: "2024 - 2025", imgspath: 'events5', eventsjson: event24 }} />} />
              <Route path="events23-24" element={<Events2223 props={{ year: "2023 - 2024", imgspath: 'events5', eventsjson: Event23 }} />} />
              <Route path="events22-23" element={<Events2223 props={{ year: "2022 - 2023", imgspath: 'events5', eventsjson: events5 }} />} />
              <Route path="events21-22" element={<Events2223 props={{ year: "2021 - 2022", imgspath: 'events5', eventsjson: Event21 }} />} />
              <Route path="events20-21" element={<Events2223 props={{ year: "2020 - 2021", imgspath: 'events5', eventsjson: event20 }} />} />
              <Route path="events19-20" element={<Events2223 props={{ year: "2019 - 2020", imgspath: 'events5', eventsjson: event19 }} />} />
              <Route path="events18-19" element={<Events2223 props={{ year: "2018 - 2019", imgspath: 'events5', eventsjson: event18 }} />} />
              <Route path="upcoming" element={<UpComingEvns />} />
            </Route>

            <Route path="team18" element={<Team props={{ yearContent: teamDataMap['2018-2019'], imgspath: 'team18' }} />} />
            <Route path="team19" element={<Team props={{ yearContent: teamDataMap['2019-2020'], imgspath: 'team19' }} />} />
            <Route path="team20" element={<Team props={{ yearContent: teamDataMap['2020-2021'], imgspath: 'team20' }} />} />
            <Route path="team21" element={<Team props={{ yearContent: teamDataMap['2021-2022'], imgspath: 'team21' }} />} />
            <Route path="team22" element={<Team props={{ yearContent: teamDataMap['2022-2023'], imgspath: 'team22' }} />} />
            <Route path="team23" element={<Team props={{ yearContent: teamDataMap['2023-2024'], imgspath: 'team23' }} />} />
            <Route path="team24" element={<Team props={{ yearContent: teamDataMap['2024-2025'], imgspath: 'team24' }} />} />
            <Route path="team25" element={<Team props={{ yearContent: teamDataMap['2025-2026'], imgspath: 'team25' }} />} />

            <Route path="gallery" element={<Gallery />} />
            <Route path="memberships" element={<Memberships />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
// import React from 'react'
// import Team from './components/Team'

// function App() {
//   return (
//     <div>
//       <Team/>
//     </div>
//   )
// }

// export default App